import { joinCorpVerify, useAuthMfa } from '@fx-ui/platform-sdk';
import { Message } from '@fx-ui/fine-design';
import Intl from '@fx-ui/intl';
import { assign, get, getApi, getUrlParameter, isEmpty, post, size } from '~/utils';
import { API, ECode, URL_PARAMETER } from '~/constants';
import { isInvitationMode } from '../utils/invite';
import { handleRedirect } from '../utils/register';

const useJoinCorp = () => {
    const { handleMfaError, renderAuthMfa } = useAuthMfa();

    const joinCorpSuccessToast = (isHostGuestDockerExceeded?: boolean) => {
        // 接受邀请接口成功后，为了防止用户重复点击，此处让注册按钮一直处于loading状态，和 FXD-41168 同理
        return new Promise(() => {
            if (isHostGuestDockerExceeded) {
                Message.success(Intl.get('corp.join.success'));
                Message.warning(
                    Intl.get('contact.docking.people.over.limit2'),
                    undefined,
                    handleRedirect
                );
            } else {
                Message.success(Intl.get('corp.join.success'), undefined, handleRedirect);
            }
        });
    };

    const joinCorp = (corpList: any[]) => {
        if (size(corpList) === 1 && isEmpty(get(corpList, [0, 'memberId'])) && isInvitationMode) {
            // 公开链接邀请
            const publicInviteConfig = {
                is_public: true,
                invited_by: get(corpList, [0, 'corpId'], '')
            };
            const hostCorpId = getUrlParameter(URL_PARAMETER.HOST_CORP_ID);
            if (hostCorpId) {
                assign(publicInviteConfig, {
                    host_corp_id: hostCorpId
                });
            }
            const deptNo = getUrlParameter(URL_PARAMETER.DEPT_NO);
            if (deptNo) {
                assign(publicInviteConfig, {
                    dept_no: deptNo
                });
            }
            return joinCorpVerify(publicInviteConfig)
                .then((res) => {
                    const isHostGuestDockerExceeded = res?.data?.is_host_guest_docker_exceeded;
                    return joinCorpSuccessToast(isHostGuestDockerExceeded);
                })
                .catch((error) => {
                    handleMfaError(error, () => {
                        joinCorp(corpList);
                    });
                    return Promise.reject();
                });
        } else {
            // 私有邀请
            const memberType = getUrlParameter(URL_PARAMETER.MEMBER_TYPE);
            const memberTypeParams = {};
            if (isInvitationMode && memberType) {
                assign(memberTypeParams, {
                    member_type: Number(memberType)
                });
            }
            return post(
                getApi(API.account.batch_join_corp),
                {
                    ...memberTypeParams,
                    invitations: corpList
                },
                {
                    customHandleErrorCodes: [
                        ECode.USER_MFA_REQUIRED,
                        ECode.USER_PHONE_UNBIND_BEFORE_MFA
                    ]
                }
            )
                .then(() => {
                    return joinCorpSuccessToast();
                })
                .catch((error) => {
                    handleMfaError(error, () => {
                        joinCorp(corpList);
                    });
                    return Promise.reject();
                });
        }
    };

    return {
        renderAuthMfa,
        joinCorp
    };
};

export default useJoinCorp;
